/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgDatapointCommentCreatedRequest } from '../../models/esg-datapoint-comment-created-request';

export interface MailEsgDatapointCommentCreated$Params {
      body: EsgDatapointCommentCreatedRequest
}

export function mailEsgDatapointCommentCreated(http: HttpClient, rootUrl: string, params: MailEsgDatapointCommentCreated$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, mailEsgDatapointCommentCreated.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

mailEsgDatapointCommentCreated.PATH = '/mail/esg-datapoint-comment-created';
